import { render, staticRenderFns } from "./CustomSvg.vue?vue&type=template&id=61e94110"
import script from "./CustomSvg.vue?vue&type=script&lang=js"
export * from "./CustomSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports